function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCybergold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#f6931d",
    d: "M 219.5,-0.5 C 238.167,-0.5 256.833,-0.5 275.5,-0.5C 359.648,10.82 424.148,52.4866 469,124.5C 471.435,131.571 469.101,135.904 462,137.5C 415.545,121.088 373.045,127.922 334.5,158C 328.806,163.027 323.473,168.36 318.5,174C 315.5,174.667 312.5,174.667 309.5,174C 273.579,148.41 235.912,145.743 196.5,166C 157.846,190.481 141.013,225.648 146,271.5C 155.298,315.133 181.465,342.966 224.5,355C 255.243,361.376 283.243,355.376 308.5,337C 312.167,335 315.833,335 319.5,337C 354.434,375.25 397.434,388.583 448.5,377C 452.743,375.197 457.077,373.697 461.5,372.5C 469.063,373.737 471.563,378.071 469,385.5C 467.708,387.249 466.542,389.082 465.5,391C 433.048,391.469 411.548,406.969 401,437.5C 399.928,445.797 399.261,454.13 399,462.5C 359.726,490.762 315.892,507.095 267.5,511.5C 254.167,511.5 240.833,511.5 227.5,511.5C 137.643,501.499 69.4762,457.833 23,380.5C 13.4658,362.112 5.63247,343.112 -0.5,323.5C -0.5,277.833 -0.5,232.167 -0.5,186.5C 28.4575,93.7122 89.7909,33.5455 183.5,6C 195.576,3.47157 207.576,1.3049 219.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#f6931d",
    d: "M 511.5,213.5 C 511.5,241.5 511.5,269.5 511.5,297.5C 485.642,346.094 445.309,365.927 390.5,357C 349.922,345.755 324.089,319.922 313,279.5C 304.51,229.006 321.676,190.172 364.5,163C 411.149,141.304 453.316,147.804 491,182.5C 499.358,191.9 506.192,202.233 511.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#f6931d",
    d: "M 511.5,422.5 C 511.5,442.833 511.5,463.167 511.5,483.5C 501.718,498.555 488.051,507.889 470.5,511.5C 464.167,511.5 457.833,511.5 451.5,511.5C 430.106,507.63 414.94,495.63 406,475.5C 396.588,444.929 404.755,420.429 430.5,402C 457.763,388.918 482.43,392.585 504.5,413C 507.083,416.068 509.416,419.235 511.5,422.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybergold);
export default __webpack_public_path__ + "static/media/cybergold.1c756f35aadaae329ee14275d3f0ec5b.svg";
export { ForwardRef as ReactComponent };